import { BilbyHeader } from '@/components/bilby-header';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CustomContentSection } from '@/components/custom-content-section';
import { ScrollTop } from '@/components/scroll-top';
import { useLayoutContext } from '@/contexts';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex } from '@mantine/core';
import { useNavigate, useRouter } from '@tanstack/react-router';
import { useMemo } from 'react';
import {
	ContentSectionLocation,
	ContentSectionPlacement,
} from '../../../../backend/src/types.generated';
import styles from './styles.module.css';

export const PrivacyPage = () => {
	const navigate = useNavigate();
	const router = useRouter();
	const { isDesktop } = useLayoutContext();

	const goToSignUpButton = useMemo(
		() => (
			<StandardButton key={1} variant="filled" onClick={() => navigate({ to: '/signup' })}>
				Sign Up
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout footer={{ children: [goToSignUpButton] }}>
			<ContentPanel noPad gap="xl" pt="xl">
				<BilbyHeader title="Privacy Policy" bilby="privacy">
					<Flex align="center" gap="lg">
						<a onClick={() => router.history.back()} className={styles.downloadLink}>
							Go Back
						</a>
					</Flex>
				</BilbyHeader>
				<CustomContentSection
					location={ContentSectionLocation.Privacy}
					placement={ContentSectionPlacement.Middle}
				/>
				{isDesktop && <ScrollTop />}
			</ContentPanel>
		</PrimaryLayout>
	);
};
